/**
 * Mobile Color Variant Carousel JavaScript
 * Handles touch scrolling and progress bar for 4+ color variants
 */

document.addEventListener('DOMContentLoaded', function() {
  initializeColorCarousels();
  
  // Re-initialize on dynamic content load (for infinite scroll, filters, etc.)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initializeColorCarousels);
  }
});

function initializeColorCarousels() {
  // Only run on mobile
  if (window.innerWidth > 768) return;
  
  // Find all color variant containers in cards
  const containers = document.querySelectorAll(
    '.card .color-variants-container, ' +
    '.card-wrapper .color-variants-container, ' +
    '.template-collection .color-variants-container, ' +
    '.template-search .color-variants-container'
  );
  
  containers.forEach(container => {
    const variantsWrapper = container.querySelector('.color-variants');
    if (!variantsWrapper) return;
    
    const variants = variantsWrapper.querySelectorAll('.color-variant');
    
    // Only create carousel for 4+ variants
    if (variants.length >= 4) {
      setupCarousel(container, variantsWrapper, variants);
    }
  });
}

function setupCarousel(container, variantsWrapper, variants) {
  // Add carousel indicator class
  container.classList.add('has-carousel');
  
  // Create progress bar if it doesn't exist
  let progressBar = container.querySelector('.color-carousel-progress');
  if (!progressBar) {
    progressBar = document.createElement('div');
    progressBar.className = 'color-carousel-progress';
    
    const progressTrack = document.createElement('div');
    progressTrack.className = 'color-carousel-track';
    progressBar.appendChild(progressTrack);
    
    container.appendChild(progressBar);
  }
  
  const progressTrack = progressBar.querySelector('.color-carousel-track');
  
  // Calculate dimensions
  const containerWidth = variantsWrapper.offsetWidth;
  const scrollWidth = variantsWrapper.scrollWidth;
  const maxScroll = scrollWidth - containerWidth;
  
  // Only show progress bar if content overflows
  if (maxScroll <= 0) {
    container.classList.remove('has-carousel');
    progressBar.style.display = 'none';
    return;
  }
  
  // Show hint animation on first load
  if (!container.dataset.hintShown) {
    container.classList.add('show-hint');
    container.dataset.hintShown = 'true';
    setTimeout(() => {
      container.classList.remove('show-hint');
    }, 1500);
  }
  
  // Update progress bar width based on visible/total ratio
  const visibleRatio = containerWidth / scrollWidth;
  const trackWidth = Math.max(20, visibleRatio * 100); // Minimum 20% width for visibility
  progressTrack.style.width = trackWidth + '%';
  
  // Handle scroll events
  let isScrolling = false;
  let scrollTimeout;
  
  variantsWrapper.addEventListener('scroll', function() {
    if (!isScrolling) {
      isScrolling = true;
      variantsWrapper.classList.add('is-scrolling');
    }
    
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      isScrolling = false;
      variantsWrapper.classList.remove('is-scrolling');
    }, 150);
    
    updateProgressBar();
    updateEdgeFades();
  });
  
  // Update progress bar position
  function updateProgressBar() {
    const scrollLeft = variantsWrapper.scrollLeft;
    const scrollPercentage = scrollLeft / maxScroll;
    const maxTranslate = 100 - trackWidth;
    const translateX = scrollPercentage * maxTranslate;
    
    progressTrack.style.transform = `translateX(${translateX}%)`;
  }
  
  // Update edge fade indicators
  function updateEdgeFades() {
    const scrollLeft = variantsWrapper.scrollLeft;
    
    if (scrollLeft > 10) {
      container.classList.add('scrolled-start');
    } else {
      container.classList.remove('scrolled-start');
    }
    
    if (scrollLeft >= maxScroll - 10) {
      container.classList.add('scrolled-end');
    } else {
      container.classList.remove('scrolled-end');
    }
  }
  
  // Enhanced touch handling for smooth swiping
  let startX = 0;
  let scrollStart = 0;
  let isDragging = false;
  
  variantsWrapper.addEventListener('touchstart', handleTouchStart, { passive: true });
  variantsWrapper.addEventListener('touchmove', handleTouchMove, { passive: true });
  variantsWrapper.addEventListener('touchend', handleTouchEnd, { passive: true });
  
  // Mouse events for testing on desktop with device emulation
  variantsWrapper.addEventListener('mousedown', handleMouseDown);
  variantsWrapper.addEventListener('mousemove', handleMouseMove);
  variantsWrapper.addEventListener('mouseup', handleMouseUp);
  variantsWrapper.addEventListener('mouseleave', handleMouseUp);
  
  function handleTouchStart(e) {
    startX = e.touches[0].clientX;
    scrollStart = variantsWrapper.scrollLeft;
    isDragging = true;
  }
  
  function handleTouchMove(e) {
    if (!isDragging) return;
    
    const currentX = e.touches[0].clientX;
    const diff = startX - currentX;
    variantsWrapper.scrollLeft = scrollStart + diff;
  }
  
  function handleTouchEnd() {
    isDragging = false;
    
    // Snap to nearest variant
    snapToNearestVariant();
  }
  
  function handleMouseDown(e) {
    // Only handle in development/testing
    if (window.innerWidth > 768) return;
    
    e.preventDefault();
    startX = e.clientX;
    scrollStart = variantsWrapper.scrollLeft;
    isDragging = true;
    variantsWrapper.style.cursor = 'grabbing';
  }
  
  function handleMouseMove(e) {
    if (!isDragging || window.innerWidth > 768) return;
    
    e.preventDefault();
    const currentX = e.clientX;
    const diff = startX - currentX;
    variantsWrapper.scrollLeft = scrollStart + diff;
  }
  
  function handleMouseUp(e) {
    if (!isDragging) return;
    
    isDragging = false;
    variantsWrapper.style.cursor = 'grab';
    
    // Snap to nearest variant
    if (window.innerWidth <= 768) {
      snapToNearestVariant();
    }
  }
  
  // Snap scrolling to nearest variant
  function snapToNearestVariant() {
    const variantWidth = variants[0].offsetWidth + 8; // width + gap
    const scrollLeft = variantsWrapper.scrollLeft;
    const nearestIndex = Math.round(scrollLeft / variantWidth);
    const targetScroll = nearestIndex * variantWidth;
    
    variantsWrapper.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
  }
  
  // Prevent default link behavior while scrolling
  variants.forEach(variant => {
    variant.addEventListener('click', function(e) {
      if (isScrolling) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  });
  
  // Initial state
  updateProgressBar();
  updateEdgeFades();
  
  // Handle window resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      if (window.innerWidth > 768) {
        // Remove carousel on desktop
        container.classList.remove('has-carousel', 'scrolled-start', 'scrolled-end');
        progressBar.style.display = 'none';
      } else {
        // Re-initialize on mobile
        const newMaxScroll = variantsWrapper.scrollWidth - variantsWrapper.offsetWidth;
        if (newMaxScroll > 0) {
          container.classList.add('has-carousel');
          progressBar.style.display = '';
          updateProgressBar();
          updateEdgeFades();
        }
      }
    }, 250);
  });
}

// Utility function to check if element is in viewport
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// Initialize carousels for dynamically loaded content
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        setTimeout(initializeColorCarousels, 100);
      }
    });
  });
  
  // Observe the body for changes (for infinite scroll, AJAX filters, etc.)
  const targetNode = document.querySelector('.collection, .search-results, #main-collection-product-grid');
  if (targetNode) {
    observer.observe(targetNode, {
      childList: true,
      subtree: true
    });
  }
}
